export class SessionToken {
  accessToken?: string;
  refreshToken?: string;
  idToken?: string;

  constructor(params?: Partial<SessionToken>) {
    Object.assign(this, params)
  }
}